import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { blogPosts } from '../content/blog/blogList';

const HomeBlogGrid: React.FC = () => {
  const featuredPosts = blogPosts.filter((post) => post.image).slice(0, 6);

  return (
    <section className="home-blog-grid py-5" id="blog">
      <Container>
        <div className="text-center mb-5">
          <h2 className="section-title mb-3">From Our Blog</h2>
          <p className="section-subtitle">
            Practical tactics, workflows, and growth playbooks for home service teams.
          </p>
        </div>

        <Row className="g-4">
          {featuredPosts.map((post) => (
            <Col key={post.id} lg={4} md={6}>
              <Card className="h-100 shadow-sm border-0 blog-card">
                {post.image && (
                  <div className="overflow-hidden" style={{ height: '200px' }}>
                    <Card.Img
                      variant="top"
                      src={post.image}
                      alt={post.title}
                      style={{
                        objectFit: 'contain',
                        height: '100%',
                        width: '100%'
                      }}
                    />
                  </div>
                )}
                <Card.Body className="d-flex flex-column">
                  <div className="mb-3">
                    <span className="text-muted small">{post.date}</span>
                    <span className="text-muted small ms-3">{post.readTime}</span>
                  </div>
                  <Card.Title className="h5 mb-3">
                    <Link to={`/blog/${post.slug}`} className="text-decoration-none text-dark blog-title">
                      {post.title}
                    </Link>
                  </Card.Title>
                  <Card.Text className="text-muted flex-grow-1">
                    {post.excerpt}
                  </Card.Text>
                  <div className="mt-3">
                    <Link to={`/blog/${post.slug}`} className="btn btn-outline-primary">
                      Read Article
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <div className="text-center mt-5">
          <Link to="/blog" className="btn btn-modern-primary">
            View All Blog Posts
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default HomeBlogGrid;
